import { object, ObjectSchema, string } from 'yup';

import { SpaceSource, SpaceSourceExternalReferenceValue } from '@client/api';

const schema: ObjectSchema<SpaceSourceExternalReferenceValue> = object({
  integration: string<SpaceSource>().required(),
  identifier: string().required()
});

export { schema as spaceSourceExternalReferenceValueSchema };
